import { forwardRef } from "react";

export const CopyIcon = forwardRef<
    SVGSVGElement,
    React.SVGProps<SVGSVGElement>
>((props, ref) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
        ref={ref}
    >
        <path
            d="M5.1999 10.7999H3.7999C3.0267 10.7999 2.3999 10.1731 2.3999 9.3999V3.7999C2.3999 3.0267 3.0267 2.3999 3.7999 2.3999H9.3999C10.1731 2.3999 10.7999 3.0267 10.7999 3.7999V5.1999M6.5999 13.5999H12.1999C12.9731 13.5999 13.5999 12.9731 13.5999 12.1999V6.5999C13.5999 5.8267 12.9731 5.1999 12.1999 5.1999H6.5999C5.8267 5.1999 5.1999 5.8267 5.1999 6.5999V12.1999C5.1999 12.9731 5.8267 13.5999 6.5999 13.5999Z"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
));

CopyIcon.displayName = "CopyIcon";
